export default __webpack_public_path__ + "img/FairwayDr-GoogleMaps-2.a2b2ea46.png";